<button
  type="button"
  (click)="loginWithFacebook()"
  [disabled]="loading"
  [class]="className"
>
<mat-icon class="facebook-icon" [class.small-icon]="!buttonSize">facebook</mat-icon>
  Log in with Facebook
</button>
